import React from "react";
import { Link } from "react-router-dom";

function CommonStyles() {
  return (
    <style jsx>{`
      .container {
        max-width: 960px;
        margin: 0 auto;
        padding: 20px;
        line-height: 1.5;
        font-size: 15px;
        font-family: "FreeSans", sans-serif;
        color: #222;
      }

      header h1 {
        font-size: 2.5rem;
        margin-bottom: 20px;
        font-weight: 700;
      }

      .text p {
        margin-bottom: 1em;
        font-size: 0.95rem;
        color: #333;
      }

      h2 {
        margin-top: 2.5em;
        font-size: 1.8rem;
        font-weight: 600;
      }

      .lang-switch {
        position: absolute;
        top: 20px;
        right: 20px;
      }

      .lang-switch button {
        background: #000;
        color: #fff;
        padding: 5px 12px;
        border-radius: 6px;
        font-size: 0.8rem;
        border: none;
        cursor: pointer;
        transition: opacity 0.25s ease;
      }

      .lang-switch button:hover {
        opacity: 0.8;
      }

          .back-button {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
        }

        .back-button button {
          background: #000;
          color: #fff;
          padding: 6px 14px;
          border-radius: 8px;
          font-size: 0.9rem;
          border: none;
          cursor: pointer;
          transition: opacity 0.25s ease;
        }

        .back-button button:hover {
          opacity: 0.8;
        }

     

      @media (max-width: 600px) {
        .container {
          padding: 16px;
          font-size: 14px;
        }

        .text p {
          font-size: 0.8rem;
        }

        header h1 {
          font-size: 1.8rem;
        }

        h2 {
          font-size: 1.4rem;
        }
      }
    `}</style>
  );
}

export default function ArchivEn() {
  return (
    <article className="container">
      <div className="lang-switch">
        <Link to="/ArchivDe">
          <button>DE</button>
        </Link>
      </div>

      <header>
        <h1>Time Lines</h1>
      </header>

      <section className="text">
        <p><strong>Archive of Memory – Art as a Storage of Time</strong></p>
        <p>Time Lines since 2025</p>
        <p>by Billi Thanner</p>

        <p>I work with lines.</p>
        <p>But in truth, I work with memory.</p>

        <p>
          My ideas arise from nature –
          from stone, light, wind, and water.
          And at the same time, from the sky.
        </p>

        <p>
          They emerge from the thought
          that the world is not separated, but connected.
        </p>

        <p>
          The colors of my works come from the earth:
          stone, dust, metal, light.
          Their luminosity is a form of remembrance.
        </p>

        <p>
          Each line that appears carries a moment,
          a thought, a state, an inner image.
          The lines connect what is with what was and what is yet to come.
          They create an archive –
          not an archive of facts, but of feeling.
        </p>

        <p>
          All of this arises from the attempt
          to grasp the present moment –
          that brief instant which becomes still.
          We find light and frequencies within the works,
          because I seek to preserve these unstoppable moments of our existence
          within my art.
        </p>

        <p>
          I believe that time does not pass,
          but transforms.
          It is stored in light, color, and material.
        </p>

        <p>
          My Time Lines are an archive of memory –
          and at the same time, a call into the future.
        </p>

        <p>
          When I work, I listen.
          I do not search for form,
          but attend to what is already there.
          And sometimes a line emerges –
          clear, calm, necessary.
        </p>

        <p>
          This series is my way of speaking with the world –
          with space, with time, with light,
          with everything that was and remains.
        </p>

        <p>
          When we become still in front of a work,
          the archive begins to speak –
          without words, only as a felt memory.
          It requires no language,
          only our gaze.
          And whoever wishes, can truly see.
        </p>

        <p><strong>Billi Thanner</strong></p>
      </section>

      <div className="back-button">
        <Link to="/Timelines">
          <button>back</button>
        </Link>
      </div>

      <CommonStyles />
    </article>
  );
}